import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SortIcons = ({ sortObj, sortName }) => {
  return (
    <>
      {
        sortObj.name === sortName ?
        sortObj.order === "asc" ?
        <FontAwesomeIcon icon="sort-up" />
        :
        <FontAwesomeIcon icon="sort-down" />
        :
        <FontAwesomeIcon icon="sort" />
      }
    </>
  );
};

export default SortIcons;
